import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  CreateOrUpdateContributorModel,
  GetContributorByIdResponse,
  GetContributorsResponse,
  GetCurrentContributorResponse,
  ProblemDetails
} from '../../models';

import { useCustomWelcomeClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns a list of contributors<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useGetContributorsHook = () => {
        const getContributors = useCustomWelcomeClient<GetContributorsResponse>();

        return useCallback((

 signal?: AbortSignal
) => {


        return getContributors(
          {url: `/contributors`, method: 'GET', signal
    },
          );
        }, [getContributors])
      }




export const getGetContributorsQueryKey = () => {
    return [
    `/contributors`
    ] as const;
    }


export const useGetContributorsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContributorsQueryKey();

  const getContributors =  useGetContributorsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>> = ({ signal }) => getContributors(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContributorsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>>
export type GetContributorsQueryError = ErrorType<ProblemDetails>


export function useGetContributors<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContributors<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContributors<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContributors<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetContributorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new contributor<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useCreateContributorHook = () => {
        const createContributor = useCustomWelcomeClient<GetContributorByIdResponse>();

        return useCallback((
    createOrUpdateContributorModel: CreateOrUpdateContributorModel,
 signal?: AbortSignal
) => {


        return createContributor(
          {url: `/contributors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContributorModel, signal
    },
          );
        }, [createContributor])
      }




export const useCreateContributorMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>, TError,CreateContributorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>, TError,CreateContributorMutationVariables, TContext> => {

const mutationKey = ['createContributor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createContributor =  useCreateContributorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>, CreateContributorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createContributor(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContributorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>>
    export type CreateContributorMutationBody = CreateOrUpdateContributorModel
    export type CreateContributorMutationError = ErrorType<ProblemDetails>
    export type CreateContributorMutationVariables = {data: CreateOrUpdateContributorModel}

    export const useCreateContributor = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>, TError,CreateContributorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateContributorHook>>>,
        TError,
        CreateContributorMutationVariables,
        TContext
      > => {
      return useMutation(useCreateContributorMutationOptions(options), queryClient);
    }
    /**
 * Returns a contributor by its id<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetContributorByIdHook = () => {
        const getContributorById = useCustomWelcomeClient<GetContributorByIdResponse>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {


        return getContributorById(
          {url: `/contributors/${id}`, method: 'GET', signal
    },
          );
        }, [getContributorById])
      }




export const getGetContributorByIdQueryKey = (id: string,) => {
    return [
    `/contributors/${id}`
    ] as const;
    }


export const useGetContributorByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError = ErrorType<ProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContributorByIdQueryKey(id);

  const getContributorById =  useGetContributorByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>> = ({ signal }) => getContributorById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContributorByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>>
export type GetContributorByIdQueryError = ErrorType<ProblemDetails>


export function useGetContributorById<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContributorById<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContributorById<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContributorById<TData = Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContributorByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetContributorByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Updates a contributor<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useUpdateContributorHook = () => {
        const updateContributor = useCustomWelcomeClient<GetContributorByIdResponse>();

        return useCallback((
    id: string,
    createOrUpdateContributorModel: CreateOrUpdateContributorModel,
 signal?: AbortSignal
) => {


        return updateContributor(
          {url: `/contributors/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContributorModel, signal
    },
          );
        }, [updateContributor])
      }




export const useUpdateContributorMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>, TError,UpdateContributorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>, TError,UpdateContributorMutationVariables, TContext> => {

const mutationKey = ['updateContributor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateContributor =  useUpdateContributorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>, UpdateContributorMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateContributor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContributorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>>
    export type UpdateContributorMutationBody = CreateOrUpdateContributorModel
    export type UpdateContributorMutationError = ErrorType<ProblemDetails>
    export type UpdateContributorMutationVariables = {id: string;data: CreateOrUpdateContributorModel}

    export const useUpdateContributor = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>, TError,UpdateContributorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateContributorHook>>>,
        TError,
        UpdateContributorMutationVariables,
        TContext
      > => {
      return useMutation(useUpdateContributorMutationOptions(options), queryClient);
    }
    /**
 * Returns the current contributor<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetCurrentContributorHook = () => {
        const getCurrentContributor = useCustomWelcomeClient<GetCurrentContributorResponse>();

        return useCallback((

 signal?: AbortSignal
) => {


        return getCurrentContributor(
          {url: `/contributors/me`, method: 'GET', signal
    },
          );
        }, [getCurrentContributor])
      }




export const getGetCurrentContributorQueryKey = () => {
    return [
    `/contributors/me`
    ] as const;
    }


export const useGetCurrentContributorQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentContributorQueryKey();

  const getCurrentContributor =  useGetCurrentContributorHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>> = ({ signal }) => getCurrentContributor(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentContributorQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>>
export type GetCurrentContributorQueryError = ErrorType<ProblemDetails>


export function useGetCurrentContributor<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentContributor<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentContributor<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentContributor<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentContributorHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCurrentContributorQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






